import { EmptyCell } from 'components/Kizen/Table';
import { getColumnNumeric } from 'components/Fields/InlineTableFieldInput';
import { SortableHeadCell } from './Table';
import { getFieldsDescription } from 'components/Fields/FieldInput/helpers';

export const CustomFieldHeadCell = ({
  field = null,
  column = null,
  ...others
}) => {
  if (!field) {
    return <EmptyCell {...others} />;
  }
  const { withNameDescription } = getFieldsDescription(field);
  return (
    <SortableHeadCell
      by={field.id}
      numeric={getColumnNumeric(field)}
      column={column}
      {...others}
      description={withNameDescription}
    />
  );
};
